$(document)
  .ready(($) => {
    if ($('.js-slider-swiper').length) {
      const swiper = new Swiper('.js-slider-swiper', {
        // Optional parameters
        loop: true,

        // If we need pagination
        pagination: {
          el: '.c-slider-swiper__pagination',
          type: 'bullets',
          bulletClass: 'c-slider-swiper__bullet',
          bulletActiveClass: 'is-active',
          clickable: true,
        },

        slidesPerView: 1,
        centeredSlides: true,
        centeredSlidesBounds: true,

        // Navigation arrows
        navigation: {
          nextEl: '.c-slider-swiper__arrow--next',
          prevEl: '.c-slider-swiper__arrow--prev',
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
        },
      });
    }

    if ($('.js-slider-swiper-gallery').length) {
      const swiperGallery = new Swiper('.js-slider-swiper-gallery', {
        // Optional parameters
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        slidesPerView: 1,
        centeredSlides: true,
        centeredSlidesBounds: true,

        // Navigation arrows
        navigation: {
          nextEl: '.c-slider-swiper__arrow--next',
          prevEl: '.c-slider-swiper__arrow--prev',
        },
      });
    }
  });
